﻿import { Environment } from "../TSScripts/environment";
import { Service } from "../TSScripts/service";
import { Loader } from "../TSScripts/loader";
/*import * as $ from "jquery";*/
import './jquery';
import "jquery-mask-plugin";
import "jquery-validation"
import "jquery-validation-unobtrusive";
import "bootstrap";
import { StatusBarWidget } from "./StatusBar";
import { SignatureWidget } from "./signature";
import { Popover } from "bootstrap";

export class ListWidget {
    private element: HTMLElement;
    private service: Service;
    private statusBarWidget: StatusBarWidget;
    private debug: boolean = false;
    private Validator: JQueryValidation.Validator;
    private _pageD: number;
    private _pageT: number;
    private _pageDe: number;
    private fileName: string;

    constructor(element: HTMLElement, statusBarWidget: StatusBarWidget) {
        this.element = element;
        this.service = new Service(Environment.applicationUrl, this.element);
        this.statusBarWidget = statusBarWidget;
        this.init();
        this._pageD = 0;
        this._pageDe = 0;
        this._pageT = 0;
    }

    init() {
        let th = this;
        $('[data-name=btnSubmitDenial]').off();
        $('[data-name=btnSubmitDenial]').on("click", (ev: Event) => th.submitDenial(ev));

        $('[data-name=btnSubmitSign]').off();
        $('[data-name=btnSubmitSign]').on("click", (ev: Event) => th.sign(ev));
        $('.docCheck').off();
        $('.docCheck').on("change", (ev: Event) => th.checkChange(ev));
        $('[data-name=btnSignAll]').off();
        $('[data-name=btnSignAll]').on("click", (ev: Event) => th.submitAll(ev));


        $('.pagination.signt li a').off();
        $('.pagination.signt li a').on("click", (ev: Event) => {
            ev.preventDefault();
            this.paginate($(ev.target).data("ordinal"), "signt", $(ev.target).data("url"));
        });
        
        $('.pagination.signd li a').off();
        $('.pagination.signd li a').on("click", (ev: Event) => {
            ev.preventDefault();
            this.paginate($(ev.target).data("ordinal"), "signd", $(ev.target).data("url"));
        });

        $('.pagination.denied li a').off();
        $('.pagination.denied li a').on("click", (ev: Event) => {
            ev.preventDefault();
            this.paginate($(ev.target).data("ordinal"), "denied", $(ev.target).data("url"));
        });
        
        $("#signt .head input[type=checkbox]").off();
        $("#signt .head input[type=checkbox]").on("click", (ev: Event) => th.checkAll(ev));

        $('[data-name=btnDownloadDocument]').off();
        $('[data-name=btnDownloadDocument]').on("click", (ev: Event) => th.downloadDocument(ev));
        
        $('[data-name=btnDownload]').off();
        $('[data-name=btnDownload]').on("click", (ev: Event) => th.download(ev));
        
        this.checkPostSignature();

        const isEllipsisActive = (el) => {
            return el.offsetHeight < el.scrollHeight;
        };
        let elements = $(".overflow-detection");
        elements.each((i, el) => {
            if (isEllipsisActive(el)) {
                $(el).addClass("has-overflow");
            }
        })
        $("#checkOverflow").on("click", () => {
            elements.each((i, el) => {
                if (isEllipsisActive(el)) {
                    $(el).addClass("has-overflow");
                }
            })
        })
        const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
        const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new Popover(popoverTriggerEl))
    }

    //pagination
    async paginate(page, table, url) {        
        this._showLoader();
        this._debugging("paginating: " +table + " - " + page);
        if (table == "signd") this._pageD = page;
        if (table == "signt") this._pageT = page;
        if (table == "denied") this._pageDe = page;
        //let url = "list/" + table +'/'+ page;        
        let el = $(`.table-wrap.${table}`);
        this._debugging(el);
        await this.service.GetView(url, el, this.statusBarWidget);        
        this.init();
        this._hideLoader();
        //this.setFlag(page, table);
    }

    //end pagination
    //check all
    checkAll(ev: Event) {
        let val = $(ev.target).is(":checked");
        $('.docCheck').each(function () {
            ($(this) as JQuery<HTMLInputElement>)[0].checked = val;
        });
        $(".btnSignAllWrap").prop("hidden", !val);
    }
    //end check all
    checkChange(ev: Event) {
        let none = true;
        ($("#signt input[type=checkbox]") as JQuery<HTMLInputElement>)[0].checked = false;
        $('.docCheck').each(function () {
            if ($(this).is(":checked")) {
                none = false;
            }
        });
        $(".btnSignAllWrap").prop("hidden", none);
    }

    //denial
    async submitDenial(ev: Event) {
        ev.preventDefault();
        this._showLoader();
        this._debugging("submitting documents");
        //let id = $(ev.target).data("id"); //Tole je id na gumbu ne pa form id....        
        let url = $(ev.currentTarget).data("url");
        let formElement = $(ev.target).closest("form");//$(this.element).find(`#form[data-id=${id}]`) as JQuery<HTMLFormElement>;
        this._debugging(formElement);
        let el = $(`.table-wrap.signt`);
        let inputField = $(formElement).find("input[name='RazlogZavrnitve']");
        

        //unobtrusive
        formElement.validate();
        $.validator.messages.required = inputField.attr("errormessage");//$("input[name='RazlogZavrnitve']").attr("errormessage");
        $(inputField).rules('add', { required: true });
        //$("input[name='RazlogZavrnitve']").rules('add', { required: true });
        if (!formElement.valid()) {
            this._hideLoader();
            return false;
        }
        
        let data = formElement.serializeArray();
        //let valid = true;
        //data.forEach((e, i) => {
        //    if (e.value == null || e.value == "") {                               
        //        valid = false;
        //    }
        //})

        //if (valid == false) {
        //    this._hideLoader();
        //    this.statusBarWidget.setStatus("Razlog zavrnitve je obvezen!", "bad");
        //    return;
        //}
        
        

        this._debugging("ready to post");
        this._debugging(data);

        //let url = "submit-denial/"+this._pageT;

        await this.service.PostObject(data, el, url, this.statusBarWidget);
        this.statusBarWidget.setStatus($(ev.currentTarget).data("success"), "ok");
        this._hideLoader();
        $(ev.target).closest('.modal').modal('toggle');
        this._debugging("posted");
        this.init();
    }
    refreshDenialTable() {

    }
    sign(ev: Event) {
        this._debugging("sign");
        this._showLoader();
        let th = this;
        let ids = [];

        //let id = $(ev.target).data("id");
        //ids = id.split(';');
        ////ids.push(id);
        let jobId = $(ev.currentTarget).data("jobId");
        let signerId = $(ev.currentTarget).data("signerId");
        let data = JSON.stringify({ ids: ids });
        let url = $(ev.currentTarget).data("url");

        //this.checkSignaturePosition(data)
            //.then((idsToSet) => th.forEachDocumentSetModal(idsToSet))
        th.checkSignOptions(ids)
            .then((options) => th.signDocuments(jobId, signerId, options, url))
    }
    submitAll(ev: Event) {
        this._debugging("sign multi");
        let th = this;
        let ids = [];

        $('.docCheck').each(function () {
            if ($(this).is(":checked")) {
                ids.push($(this).data("id"));
            }
        });  
        let data = JSON.stringify({ ids: ids, callBack: window.location.href });

        throw new Error("Not implemented");
        //th.checkSignOptions(ids)
        //    .then((options) => th.signDocuments(ids, options))
                
            
    }
    
    getDocument(url, id) {          
        try {
            this._debugging("getDocument");
            let th = this;
            return new Promise(function (resolve) {
                let self = th;
                $.ajax({
                    type: 'POST',
                    url: url,
                    data: { idZahtevka: id },
                    cache: false,
                    xhrFields: {
                        withCredentials: true
                    } ,
                    xhr: function () {
                        var xhr = new XMLHttpRequest();
                        xhr.onreadystatechange = function () {
                            if (xhr.readyState == 2) {
                                if (xhr.status == 200) {
                                    xhr.responseType = "blob";
                                } else {
                                    xhr.responseType = "text";
                                }
                            }
                        };
                        return xhr;
                    },
                }).done((data) => resolve(data))
                    .fail((xhr, status, error) => self.service.onPostFail(xhr, status, error, self.statusBarWidget))
            });
        } catch (e) {
            console.log(e);
        }
    }
    setModalDoc(data: any, signatureService: SignatureWidget, signeeCount:number) {
        this._debugging("setModalDoc");
        let th = this;
        var blob = new Blob([data], { type: "application/octetstream" });
        this._hideLoader();
        signatureService.initPdf(blob, signeeCount);
        return new Promise(function (resolve) {
            $(".confirmrect").one("click", function (ev: any) {
                th._showLoader();
                resolve(true);
            })  
            $('#signature-modal').one('hide.bs.modal', function (e) {
                th._debugging("destroy canvas");
                var canvas = (document.getElementById('the-canvas') as HTMLCanvasElement);
                canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height);
                $("#canvas").children().remove();
                $('#prev').off();
                $('#next').off();
            })
        });
    }
    sendPosition(id: any, signatureService: SignatureWidget) {
        this._debugging("sendPosition");
        signatureService.sendResults(id);
    }
    checkSignOptions(ids) {
        this._debugging("checkSignOptions");
        let th = this;
        let modal = $("#sign-options-modal");
        return new Promise(async function (resolve) {
            th._showLoader();
            let html = await th.getOptionsModal(ids, modal);
            th._debugging(html);
            if (html == null || html == "") { resolve(true) }
            else {
                modal.modal('show');
                th._hideLoader();

                $(".confirm-options").one("click", function (ev: any) {
                    th._showLoader();
                    var data = { "ContinueWith": $(ev.currentTarget).data("value") };
                    modal.modal('hide');
                    resolve(data);
                })
            }
        });
    }
    getOptionsModal(ids: any, el: JQuery<HTMLElement>) {
        let th = this;
        return new Promise<string>(function (resolve) {
            let data = JSON.stringify({ ids: ids });
            let self = th;
            th.service.PostView(data,el, "check-user-options", th.statusBarWidget).done((html) => resolve(html))
        });
    }
    /*
    async signDocuments(ids: any, options: any) {
        this._debugging(options);            
        let continueWith = "";
        let pravnaOseba = "0";
        if (options != true) {
            continueWith = options.ContinueWith;
            //options.forEach(function(e,i)  {
            //    if (e.name == 'zastopstvo') pravnaOseba = e.value;
            //    if (e.name == 'continueWith') continueWith = e.value;
            //})
        }

        let data = JSON.stringify({ ids: ids, callBack: window.location.href, ContinueWith: continueWith, PravnaOseba: pravnaOseba });
        let url = "sign";
        let th = this;
        this._showLoader();
        this._debugging("posting: " + data.toString() + " to: " + url)
        var signUrl = await this.service.PostJson(data, url, this.statusBarWidget);
        this.onPostSignDone(signUrl);
        
    }
    */
    async signDocuments(jobId: string, signerId: string, options: any, url: string) {        
        this._debugging(options);
        let continueWith = "";
        let pravnaOseba = "0";
        if (options != true) {
            continueWith = options.ContinueWith;
            //options.forEach(function(e,i)  {
            //    if (e.name == 'zastopstvo') pravnaOseba = e.value;
            //    if (e.name == 'continueWith') continueWith = e.value;
            //})
        }

        let data = JSON.stringify({ JobId: jobId, SignerId: signerId, callBack: window.location.href, ContinueWith: continueWith, PravnaOseba: pravnaOseba });
        let th = this;
        this._showLoader();
        this._debugging("posting: " + data.toString() + " to: " + url)
        var response = await this.service.PostJson(data, url, this.statusBarWidget);
        this.onPostSignDone(response);

    }

    onPostSignDone(response: any) {
        let self = this;
        if (response.success && response.redirectUrl) {
            window.location.href = response.redirectUrl;
        }
        else {
            this._hideLoader();
            this.statusBarWidget.setStatus(response.message, "bad")
        }

        window.addEventListener("message", function (event) {
            if (event.origin === response.redirectUrl) {
                alert("Response from Rekono: " + event.data);
                self._hideLoader();
            }
        });

    }

    download(ev: Event) {       
        ev.preventDefault();
        let id = $(ev.currentTarget).data("id");
        let signed = $(ev.currentTarget).data("signed") === "True";
        let url = $(ev.currentTarget).data("url");
        this.fileName = $(ev.currentTarget).data("filename");
        let th = this;
        th._showLoader();
        th.getDocument(url, id).then((data: Blob) => {
            let blob = new Blob([data], { type: "application/octetstream" });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = th.fileName;
            link.click();
            this._hideLoader();
            
        });
    }


    downloadDocument(ev: Event) {
        ev.preventDefault();
        let id = $(ev.currentTarget).data("id");
        let url = $(ev.currentTarget).data("url");
        let th = this;
        th._showLoader();
        let signed = $(ev.currentTarget).closest(".custom-table").hasClass("signd");
        let signatureService: SignatureWidget = new SignatureWidget($("#preview-widget") as unknown as HTMLElement,1,1);
        $("#preview-modal").modal('toggle');
        return new Promise((resolve) => {
            th.getDocument(url, id)
                .then((data: any) => {
                    var blob = new Blob([data], { type: "application/octetstream" });
                    this._hideLoader();
                    signatureService.initPdfPreview(blob);
                    $('[data-name=docSlider]').off('input');         //TODO
                    $('[data-name=docSlider]').on('input', function (ev: Event) {
                        var scale = $(ev.currentTarget).val();
                        $('.canvas-wrapper').css('transform', `scale(${scale}, ${scale})`);
                    }) 
                    th._hideLoader();
                    $('#preview-modal').one('hide.bs.modal', function (e) {
                        th._debugging("destroy canvas");
                        var canvas = (document.getElementsByClassName('the-canvas')[0] as HTMLCanvasElement);
                        canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height);
                        $('.prev').off();
                        $('.next').off();
                    })
                })
        })
    }
    checkPostSignature() {
        let postElement = $('#postSignature');
        if (postElement.length > 0) {
            if (postElement.data("num") == 1) this.statusBarWidget.setStatus(postElement.data("text"), "ok");
            if (postElement.data("num") == 2) this.statusBarWidget.setStatus(postElement.data("text"), "bad");
            if (postElement.data("num") == 3) this.statusBarWidget.setStatus(postElement.data("text"), "bad");
        }
    }
    _debugging(msg: any) {
        if (this.debug == true) {
            console.log(msg);
        }
    }
    _showLoader() {
        Loader.showLoader(this.element);
    }

    _hideLoader() {
        Loader.hideLoader(this.element);
    }
}
